const defaultState = {
  inputtedHours: [],
  hoursInTheWeek: [],
  projectHours: [],
  proposalHours: [],
}

export default function manageHours(state = defaultState, action) {
  switch (action.type) {
    // Return all employee hours
    case "GET_EMPLOYEE_PROJECT_HOURS_SUCCESS":
      return { ...state, projectHours: action.payload, inputtedHours: [] }
    case "GET_EMPLOYEE_PROPOSAL_HOURS_SUCCESS":
      return { ...state, proposalHours: action.payload, inputtedHours: [] }
    case "ADD_LAST_WEEK_HOURS":
      const filteredLastWeekHours = action.payload.filter(hour => {
        const foundHour = state.inputtedHours.find(newHour => {
          const projectsAreTheSame = newHour.project && hour.project && newHour.project.url === hour.project.url
          const proposalsAreTheSame = newHour.proposal && hour.proposal && newHour.proposal.url === hour.proposal.url
          return (
            (projectsAreTheSame || proposalsAreTheSame) &&
            newHour.type === hour.type &&
            newHour.date === hour.date
          )
        })
        if (foundHour) return false
        return true
      })
      return { ...state, inputtedHours: [...state.inputtedHours, ...filteredLastWeekHours] }
    case "ADD_HOURS":
      // Remove duplicates so there is only one hours object per date per project
      let inputtedHours = state.inputtedHours.filter(hour => {
        const isSameDate = hour.date === action.payload.date
        const isSameProject = !!action.payload.project && !!hour.project && hour.project.id === action.payload.project.id
        const isSameProposal = !!action.payload.proposal && !!hour.proposal && hour.proposal.id === action.payload.proposal.id
        return !(isSameDate && (isSameProject || isSameProposal))
      })
      inputtedHours = [...inputtedHours, action.payload]
      return { ...state, inputtedHours }
    case "ADD_NEW_HOURS":
      const newProjectHours = []
      const newProposalHours = []
      action.payload.forEach(hour => {
        const formattedDate = new Date(hour.date).toISOString().split('T')[0]
        const hourWithFormattedDate = {
          ...hour,
          date: formattedDate
        }
        
        if (hour.project) {
          newProjectHours.push(hourWithFormattedDate)
        }

        if (hour.proposal) {
          newProposalHours.push(hourWithFormattedDate)
        }
      })

      const filteredProjectHours = state.projectHours.filter(hour => {
        const foundProjectHour = newProjectHours.find(newHour => {
          return (
            newHour.project &&
            hour.project &&
            newHour.project.url === hour.project.url &&
            newHour.type === hour.type &&
            newHour.date === hour.date
          )
        })
        if (foundProjectHour) return false
        return true
      })

      const filteredProposalHours = state.proposalHours.filter(hour => {
        const foundProposalHour = newProposalHours.find(newHour => {
            return (
              newHour.proposal &&
              hour.proposal &&
              newHour.proposal.url === hour.proposal.url &&
              newHour.type === hour.type &&
              newHour.date === hour.date
            )
        })
        if (foundProposalHour) return false
        return true
      })
      // const newProjectHours = action.payload.filter(hour => hour.project)
      const checkIfHourIsZero = hour => Number(hour.hours) && Number(hour.hours) !== 0
      const projectHours = [...filteredProjectHours, ...newProjectHours].filter(checkIfHourIsZero)

      // const newProposalHours = action.payload.filter(hour => hour.proposal)
      const proposalHours = [...filteredProposalHours, ...newProposalHours].filter(checkIfHourIsZero)

      return {...state, projectHours, proposalHours, inputtedHours: []}
    case "RESET_INPUTTED_HOURS":
      return { ...state, inputtedHours: [] }
    case "ADD_HOURS_IN_THE_WEEK":
      return { ...state, hoursInTheWeek: [...state.hoursInTheWeek, action.payload] }
    case "RESET_HOURS_IN_THE_WEEK":
      return { ...state, hoursInTheWeek: [] }
    default:
      return state
  }
}


export const resetInputtedHours = () => {
  return {type: "RESET_INPUTTED_HOURS"}
}

//Update inputted hours to redux
export const addHours = (hours) => {
  return {type: "ADD_HOURS", payload: hours}
}


//Get and return all employee hours - might want to just filter for current user
export const successGetEmployeeProjectHours = (hours) => {
  return { type: "GET_EMPLOYEE_PROJECT_HOURS_SUCCESS", payload: hours }
}

export const successGetEmployeeProposalHours = (hours) => {
  return { type: "GET_EMPLOYEE_PROPOSAL_HOURS_SUCCESS", payload: hours }
}


export const addLastWeekHours = (hours) => {
  return { type: "ADD_LAST_WEEK_HOURS", payload: hours }
}

export const addNewHours = (newHours) => {
  return { type: "ADD_NEW_HOURS", payload: newHours }
}



// WEBPACK FOOTER //
// ./src/routes/workload/reducers/manageHours.js